
import { formatMoney } from 'utils/storefront/format-resource';
import { setRechargeDataToStorage, getRechargeDataFromStorage } from './product-form';
import ProductSliders from './product-sliders';
import extractAndFormat from '../utils/extract-and-format';
import './product-yotpo-review.css';
import './product-yotpo-subscription.css';
import './product-recharge-styles.css';
import './product-findation-widget.css';
import './product-afterpay.css';
import './product-tooltip.css';
import './product.css';
import AjaxService from '../cart/ajax-service';
import './countdown';
import './highlight-block';


export default (element, { product, sellingPlans, productInformation, earnUp, showFindationWidget, findationSetId, findationApiKey, variants, yotpoPDPSubscriptionWidgetContent, points }) => {
  let currentVariant = null;
  let currentVariantJson = null;
  let cart = null;
  let alreadyAddedQty = null;
  const input = element.querySelector('[data-quantity-input]');
  const ctaPriceSticky = element.querySelector('[data-sticky-price]');
  const ctaPrice = element.querySelector('[data-button-price]');
  const stickyImage = document.querySelector('[data-sticky-image]');
  const productForm = document.getElementById('productForm');

  let productSliders = null

  const rewardsSliderRender = () => {
    const rewardsPoints = document.querySelectorAll('.rewards-points')
    let yotpoPoints = Math.floor(currentVariantJson.price.amount * points.pointPrice);

    rewardsPoints.forEach(element => {

      if (element.innerHTML.includes('[points]')) {
        element.innerHTML = element.innerHTML.replace(
          '[points]',
          `<span
              class="swell-product-helper bg-supergoop-yellow pl-[5px] py-[1px]"
              class=" bg-supergoop-yellow pl-[5px] py-[1px]"
            >${yotpoPoints}</span>`,
        );

        element.innerHTML = element.innerHTML.replace(' points ', `<span class="bg-supergoop-yellow pr-[5px] rounded-br-[4px] py-[1px] rounded-tr-[4px]"> points</span> `);
        element.innerHTML = element.innerHTML.replace(earnUp, `<span class="bg-supergoop-yellow pl-[5px] rounded-bl-[4px] py-[1px] rounded-tl-[4px] -mr-[3px]"> Earn up to</span> `);
      } else {
        const yotpoWrapper = document.querySelector('.swell-product-helper')
        if (yotpoWrapper) {
          yotpoWrapper.innerHTML = currentVariantJson.price.amount * points.pointPrice
          yotpoWrapper.dataset.priceCents = yotpoPoints * points.pointPrice;
        }

      }
    });
  };

  const updateYotpoWrapper = () => {
    const yotpoWrapper = document.querySelector('.swell-product-helper')
    if (!yotpoWrapper) {
      return
    }

    yotpoWrapper.innerHTML = currentVariantJson.price.amount * points.pointPrice;
  }

  const updateCtaPrice = (priceCta) => {
    if (currentVariant?.selling_plan_allocations.length === 0) {
      return;
    }

    if (ctaPrice) {
      if (currentVariantJson.compareAtPrice.amount > 0) {
        ctaPrice.innerHTML = `${priceCta} <span class="inline ml-[6px] line-through">${extractAndFormat(formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 }))}</span>`;
      } else {
        ctaPrice.innerHTML = priceCta;
      }
    }
    if (ctaPriceSticky)
      if (currentVariantJson.compareAtPrice.amount > 0) {
        ctaPriceSticky.innerHTML = `${priceCta} <span class="inline ml-[6px] line-through">${extractAndFormat(formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 }))}</span>`;
      } else {
        ctaPriceSticky.innerHTML = priceCta;
      }
  }

  const enableSubscription = (e) => {
    const selectedRadio = document.querySelector('.yotpo-selected');
    if (selectedRadio?.classList?.contains('yotpo-radio-buy-once-container') === true) {

      if (document.getElementById("yotpo-subscriptions-info-block-container")) {
        document.getElementById("yotpo-subscriptions-info-block-container").style.display = "none";
      }
      if (document.querySelector("yotpo-subscription-policy-wrapper")) {
        document.querySelector("yotpo-subscription-policy-wrapper").style.display = "none";
      }
      const priceCta = extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount * input.value }))
      updateCtaPrice(priceCta)
      updateYotpoWrapper()
      return;
    }
    else {
      if (document.getElementById("yotpo-subscriptions-info-block-container")) {
        document.getElementById("yotpo-subscriptions-info-block-container").style.display = "flex";
      }

      if (document.querySelector("yotpo-subscription-policy-wrapper")) {
        document.querySelector("yotpo-subscription-policy-wrapper").style.display = "flex";
      }

      const subscriptionPriceContainer = document.querySelector('.yotpo-radio-subscription-container .yotpo-subscription-label-price');

      if (subscriptionPriceContainer) {
        const priceCta = subscriptionPriceContainer.innerHTML
        updateCtaPrice(priceCta);
        setTimeout(() => {
          updateSubscriptionPrice();
        }, 700)
      }
      return;
    }
  }
  
  // need to update soon
  const addSubscriptionInfoBlock = () => {
    const observerOptions = {
      attributes: true,
      childList: true,  // Observe direct children
      subtree: true     // Also observe changes to descendants
    };
    const intervalId = setInterval(() => {
      const targetNode = document.querySelector('.yotpo-plans-and-policy-wrapper');
      const infoBlock = document.getElementById('yotpo-subscriptions-info-block-container');
      let parent = document.getElementsByClassName("yotpo-selling-plans-wrapper")
      if (targetNode && parent) {
        if (!infoBlock)
          parent[0].insertAdjacentHTML(
            'afterend',
            yotpoPDPSubscriptionWidgetContent ? yotpoPDPSubscriptionWidgetContent : informationBlock
          );
        const observer = new MutationObserver(handleMutation);
        observer.observe(targetNode, observerOptions);
        clearInterval(intervalId)
      }
    }, 300);

    function handleMutation(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          setTimeout(() => {
            enableSubscription();
          }, 300)

        }
      }
    }
  }

  const showFindationWidgetFunc = () => {
    const initWidget = () => {
      window.Findation = window.Findation || {};
      Findation.init(
        document.getElementById("findation-widget-button"),
        findationApiKey, // Template literals not needed if it's already a string
        {
          productId: product.id,
          searchSetLookupReference: findationSetId // Template literals not needed if it's already a string
        }
      );
    };

    // Function to check for Findation and initialize widget
    const attemptInit = () => {
      if (window.Findation) {
        initWidget();
        return true; // Indicates success
      }
      return false; // Indicates failure
    };

    // Try to initialize immediately in case Findation is already loaded
    if (!attemptInit()) {
      // Only set up the interval if immediate initialization fails
      const interval = setInterval(() => {
        if (attemptInit()) {
          clearInterval(interval);
        }
      }, 100); // Added interval delay, assuming it was accidentally omitted
    }

  }

  const quantityLogic = () => {

    const minus = element.querySelector('[data-button-minus]');
    const plus = element.querySelector('[data-button-plus]');

    if (!currentVariant || !currentVariant.available) return

    plus.addEventListener('click', () => {
      if (currentVariantJson.metafields?.cartValidation && currentVariantJson.metafields?.cartValidation?.quantityLimit <= (alreadyAddedQty + (+input.value))) {
        plus.classList.add('pointer-events-none')
      } else {
        plus.classList.remove('pointer-events-none')
      }
      input.value = +input.value + 1
      updateButtonPrice(input.value)
    })

    minus.addEventListener('click', () => {
      const errorMessage = document.querySelector("[data-quantity-message]")
      if (errorMessage) {
        !errorMessage.classList.contains('hidden') && errorMessage.classList.add('hidden')
      }
      if (currentVariantJson.metafields?.cartValidation && currentVariantJson.metafields?.cartValidation?.quantityLimit <= (alreadyAddedQty + (+input.value))) {
        plus.classList.add('pointer-events-none')
      } else {
        plus.classList.remove('pointer-events-none')
      }
      if (input.value > 1)
        input.value = +input.value - 1

      updateButtonPrice(input.value)
    })

  }

  function updateOptions(optionType, currentOption, product, element) {
    // Filter variants based on the current option
    const optionPosition = product.options.indexOf(optionType) + 1;
    //const filteredVariants = variants.filter(variant => variant[`option${optionPosition}`] === currentOption);
    const filteredVariants = product.variants.filter(variant => {
      return Object.values(variant).includes(currentOption)
    });

    // Select option elements and initialize visibility counters
    const optionSelector = optionType === 'Size' ? '[data-product-option-size]' : '[data-product-option-color]';
    const options = element.querySelectorAll(optionSelector);
    let visibleCount = 0;

    // Update visibility and checked state of options
    options.forEach(option => {
      const optionValue = option.value;
      const isVisible = filteredVariants.some(variant => {
        return variant[`option${optionPosition}`] === optionValue
      });

      option.classList.toggle('disabled', !isVisible);
      option.parentNode.classList.toggle('hidden', !isVisible);
      if (isVisible) {
        visibleCount++;
        //option.checked = visibleCount === 1;
      } else {
        option.checked = false;
      }
    });
  }

  const hideVariantblocks = (e, options) => {
    if (!e || !options) {
      return
    }
    const { target } = e
    const forAttr = target.getAttribute('for');
    const filteredOptions = Array.from(options).filter(option => {
      const optionAttrFor = option.getAttribute('for');
      return forAttr != optionAttrFor;
    })

    const filteredVariants = product.variants.filter(variant => {
      return variant.options.some(option => {
        return target.value == option
      })
    })

    filteredOptions.forEach(option => {
      const someIncludes = filteredVariants.some(variant => {
        return variant.title.includes(option.value)
      })
      if (!someIncludes) {
        option.parentNode.parentNode.classList.add('hidden')
      } else {
        option.parentNode.parentNode.classList.remove('hidden')
      }
    })
  }

  const updateURL = (currentVariant) => {
    if (window.location.toString().includes('products/')) {
      const searchParams = new URLSearchParams(window.location.search);
      const id = currentVariant.id;
      searchParams.set('variant', id);
      const newRelativePathQuery = `${window.location.pathname
        }?${searchParams.toString()}`;
      window.history.pushState(null, '', newRelativePathQuery);
    }
  }

  const getCurrentVariant = (e, colorChange = false, sizeChange = false) => {

    const addToCart = element.querySelector('[data-add-to-cart]');
    const dataOneSize = element.querySelector('[data-one-size]');
    const customOptions = element.querySelectorAll('.custom-options');
    const customOptionsInput = element.querySelectorAll('.custom-options input');

    if (customOptions.length && customOptionsInput.length) {
      const currentOptions = Array.from(customOptions).map(block => {
        if (block.querySelector('input:checked') && block.querySelector('input:checked').value)
          return block.querySelector('input:checked').value;
      })

      const filteredVariant = product.variants.filter(variant => {
        return variant.options.every(option => {
          return currentOptions.includes(option)
        })
      })

      const filteredVariantJson = variants.filter(variant => {
        return variant.selectedOptions.every(option => {
          return currentOptions.includes(option.value)
        })
      })

      if (filteredVariant && filteredVariant[0]) {
        currentVariant = filteredVariant[0]
      }
      if (filteredVariantJson && filteredVariantJson[0]) {
        currentVariantJson = filteredVariantJson[0]
      }

      hideVariantblocks(e, customOptionsInput)
      updateButtonPrice(1);
      addToCart.disabled = !currentVariant.available ? true : false;

      if (stickyImage && currentVariantJson && currentVariantJson.image && currentVariantJson.image.src) {
        stickyImage.src = currentVariantJson.image.src;
        const stickyOptionSize = element.querySelector('[data-sticky-option-size]');
        const stickyOptionsColor = element.querySelector('[data-sticky-option-color]');
        stickyOptionSize.querySelector('[data-sticky-option-size-value]').innerHTML = currentVariantJson.selectedOptions && currentVariantJson.selectedOptions[0] && currentVariantJson.selectedOptions[0].value
        stickyOptionsColor.querySelector('[data-sticky-option-color-value]').innerHTML = currentVariantJson.selectedOptions && currentVariantJson.selectedOptions[1] && currentVariantJson.selectedOptions[1].value
      }
      return
    }

    const currentVariantOptionColor = element.querySelector('[data-product-option-color]:checked');
    const currentVariantOptionSize = dataOneSize ? dataOneSize.innerHTML : element.querySelector('[data-product-option-size]:checked')?.value;
    const currentVariantOptionSizeElement = element?.querySelector('[data-product-option-size]:checked');

    // single variant product
    if (product.variants.length == 1 && !currentVariantOptionColor && !currentVariantOptionSize) {
      currentVariantJson = variants[0];
      currentVariant = product.variants[0];

      if (stickyImage && currentVariantJson && currentVariantJson.image && currentVariantJson.image.src) {
        stickyImage.src = currentVariantJson.image.src;
      }

      updateButtonPrice(1);
      addToCart.disabled = !currentVariant.available ? true : false;
      
      return
    }

    if (!currentVariantOptionColor && !currentVariantOptionSize) {
      return
    }

    //find correct variant

    const checkColorExist = currentVariantOptionColor && currentVariantOptionColor?.value;
    // currentVariant = colorChange ? 
    // product.variants.find(variant => variant.id.toString() == currentVariantOptionColor.dataset.variantId.toString())
    //   : product.variants.find(variant => variant.title == `${checkColorExist ? currentVariantOptionColor.value : ''}${(currentVariantOptionSize && checkColorExist) ? ' / ' : ''}${currentVariantOptionSize ? currentVariantOptionSize : ''}`);
    
    // const availableVariants = product.variants.filter(variant => {
    //   return variant.available === true && Object.values(variant).includes(e?.target.value)
    // });

    const choosenColorOption = element.querySelector('[data-product-option-color]:checked');
    const choosenSizeOption = element.querySelector('[data-product-option-size]:checked');

    currentVariant = product.variants.filter(variant => {
      if (choosenColorOption && choosenSizeOption) {
        return Object.values(variant).includes(choosenColorOption?.value) && Object.values(variant).includes(choosenSizeOption?.value)
      }

      if (!choosenColorOption && choosenSizeOption) {
        return Object.values(variant).includes(choosenSizeOption?.value)
      }

      if (choosenColorOption && !choosenSizeOption) {
        return Object.values(variant).includes(choosenColorOption?.value)
      }

      if (!choosenColorOption && !choosenSizeOption) {
        return variant
      }
    })[0];

    updateURL(currentVariant);

    // if change color , hide sizes that do not exist 
    if (colorChange) {
      const optionPosition = product.options.indexOf('Color') + 1;
      updateOptions('Size', currentVariant[`option${optionPosition}`], product, element);
    }

    if (sizeChange) {
      const optionPosition = product.options.indexOf('Size') + 1;
      updateOptions('Color', currentVariant[`option${optionPosition}`], product, element);
    }

    // find json for additional fields
    currentVariantJson = variants.find(variant => {
      return variant.variantId == currentVariant.id
    });

    productSliders.reinit(currentVariantJson)
    rewardsSliderRender();
    // dynamically change desctiption and choosen variant name for color
    const colorDescription = element.querySelector('[data-color-description]');
    const colorMessage = element.querySelector('[data-color-message]');
    const colorChoosenOption = element.querySelector('[data-choosen-variant]');
    const sizeChoosenOption = element.querySelector('[data-choosen-variant-size]');
    const stickyOptionSize = element.querySelector('[data-sticky-option-size]');
    const stickyOptionsColor = element.querySelector('[data-sticky-option-color]');

    if (colorDescription) {
      colorDescription.innerHTML = currentVariantJson.shadeDescription;
    }

    if (colorMessage) {
      colorMessage.innerHTML = currentVariantJson?.shadeMessage || '';
      currentVariantJson?.shadeMessage ? colorMessage.classList.remove('hidden') : colorMessage.classList.add('hidden')
    }

    if (colorChoosenOption) {
      colorChoosenOption.innerHTML = checkColorExist ? currentVariantOptionColor.value : '';
      if (stickyOptionsColor) {
        stickyOptionsColor.querySelector('[data-sticky-option-color-value]').innerHTML = checkColorExist ? currentVariantOptionColor.value : '';
      }
    } else {
      stickyOptionsColor && stickyOptionsColor.classList.add('hidden')
    }

    if (sizeChoosenOption) {
      sizeChoosenOption.innerHTML = dataOneSize ? dataOneSize.innerHTML : element.querySelector('[data-product-option-size]:checked')?.value;
      if (stickyOptionSize)
        stickyOptionSize.querySelector('[data-sticky-option-size-value]').innerHTML = dataOneSize ? dataOneSize.innerHTML : element.querySelector('[data-product-option-size]:checked')?.value;
    } else {
      stickyOptionSize && stickyOptionSize.classList.add('hidden')
    }


    // logic for size short description
    const currentSizes = element.querySelectorAll('[data-product-option-size]')
    currentSizes.forEach(size => {
      let correctVariant
      if (currentVariantOptionColor) {
        correctVariant = variants.find(variant => variant.title == `${currentVariantOptionColor.value} / ${size.value}`)
      } else {
        correctVariant = variants.find(variant => variant.title.includes(size.value))
      }
      size.parentNode.parentNode.querySelector('[data-variant-description]').innerHTML = correctVariant?.shortDescription || '';
    })

    if (currentVariantOptionSizeElement) {
      currentVariantOptionSizeElement.parentNode.parentNode.querySelector('[data-variant-description]').classList.replace('text-grey-5C', 'text-grey-2A')
    }

    setTimeout(() => {
      updateSubscriptionPrice();
    }, 700);

    if (stickyImage && currentVariantJson && currentVariantJson.image && currentVariantJson.image.src) {
      stickyImage.src = currentVariantJson.image.src;
    }

    //update button price when change variant
    updateButtonPrice(1);
    // disable button if variant not available
    addToCart.disabled = !currentVariant.available ? true : false;
  }

  const updateSubscriptionPrice = () => {
    if (currentVariant?.selling_plan_allocations.length === 0) {
      return;
    }

    const intervalBuyOnce = setInterval(() => {
      const buyOnceContainer = document.querySelector('.yotpo-radio-buy-once-container .yotpo-subscription-label-price')
      if (buyOnceContainer) {
        buyOnceContainer.innerHTML = formatMoney({ amount: currentVariantJson.price.amount * 100 }, true);
        clearInterval(intervalBuyOnce);
      }
    }, 50);

    const intervalSubscription = setInterval(() => {
      const subscriptionPriceContainer2 = document.querySelector('.yotpo-radio-subscription-container .yotpo-subscription-label-price')
      if (subscriptionPriceContainer2) {
        subscriptionPriceContainer2.dataset.price = extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount }));
        clearInterval(intervalSubscription);
      }

      const subscriptionPriceContainer = document.querySelector('.yotpo-radio-subscription-container .yotpo-subscription-label-price')
      if (subscriptionPriceContainer) {
        const sellingPlan = document.querySelector('[data-selling-plan-group-frequency-id] input:checked').value;
        if (sellingPlan) {
          const percentValue = currentVariantJson.price.amount * sellingPlans[sellingPlan].value
          subscriptionPriceContainer.innerText = extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount - percentValue }));
          const yotpoWrapper = document.querySelector('.swell-product-helper')
          if (!yotpoWrapper) {
            return
          }
          yotpoWrapper.innerHTML = Math.floor(currentVariantJson.price.amount * points.pointPrice - percentValue * points.pointPrice);
          return
        }
      }
    }, 50);
  }

  const updateButtonPrice = (qty) => {
    const ctaPrice = element.querySelector('[data-button-price]');
    const productPrice = element.querySelector('[data-product-price]');
    const productOldPrice = element.querySelector('[data-product-old-price]');
    const priceHolder = element.querySelector('.price');

    if (ctaPrice) {
      if (currentVariantJson.compareAtPrice.amount > 0) {
        ctaPrice.innerHTML = `${extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount * qty }))} <span class="inline ml-[6px] line-through">${extractAndFormat(formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 }))}</span>`;
      } else {
        ctaPrice.innerHTML = extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount * qty }));
      }
    }

    if (ctaPriceSticky) {
      if (currentVariantJson.compareAtPrice.amount > 0) {
        ctaPriceSticky.innerHTML = `${extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount * qty }))} <span class="inline ml-[6px] line-through">${extractAndFormat(formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 }))}</span>`;
      } else {
        ctaPriceSticky.innerHTML = extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount * qty }));
      }
    }
    if (productPrice)
      productPrice.innerHTML = extractAndFormat(formatMoney({ amount: currentVariantJson.price.amount * 1 }));

    if (productOldPrice) {
      if (currentVariantJson.compareAtPrice.amount > 0) {
        productOldPrice.classList.remove('hidden', currentVariantJson.compareAtPrice.amount > 0);
        priceHolder?.classList.add('price--on-sale', currentVariantJson.compareAtPrice.amount > 0);
        productOldPrice.innerHTML = extractAndFormat(formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 }));
      } else {
        productOldPrice.classList.add('hidden', currentVariantJson.compareAtPrice.amount > 0);
        priceHolder?.classList.remove('price--on-sale', currentVariantJson.compareAtPrice.amount > 0);
        productOldPrice.innerHTML = extractAndFormat(formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 }));
      }
    }

    const interval = setInterval(() => {
      const buyOnceContainer = document.querySelector('.yotpo-radio-buy-once-container .yotpo-subscription-label-price')
      if (buyOnceContainer) {
        buyOnceContainer.innerHTML = formatMoney({ amount: currentVariantJson.price.amount * 100 }, true)
        clearInterval(interval);
      }
    }, 50);
  }

  const addToCartEvent = () => {
    const buttonAddToCart = element.querySelector('[data-add-to-cart]');
    const buttonAddToCartSticky = element.querySelector('[data-sticky-product-button]');
    buttonAddToCart && buttonAddToCart.addEventListener('click', handleAddToCart)
    buttonAddToCartSticky && buttonAddToCartSticky.addEventListener('click', handleAddToCart)
  }


  const saveRechargeDataToStore = () => {
    const id = currentVariantJson.id.split('/ProductVariant/')[1];
    const yotpoOptions = document.querySelectorAll('.yotpo-frequency-options input')
    if (!yotpoOptions) return

    const rechargeArrayObjects = [...yotpoOptions].map(input => {
      return {
        value: input.value,
        text: input.nextElementSibling.textContent
      }
    })
    const obj = { ...getRechargeDataFromStorage() }

    obj[id] = {
      ...rechargeArrayObjects
    }

    setRechargeDataToStorage(obj);
  }

  const handleAddToCart = async function (e) {
    e.preventDefault()

    if (e.currentTarget.classList.contains('notify-me') && e.currentTarget.hasAttribute('data-sticky-product-button')) {
      const notifyMeButton = element.querySelector('#BIS_trigger');
      notifyMeButton.click();
      return;
    }

    await getCart();
    saveRechargeDataToStore();
    // get the data from recharge 
    // checkIfSubsctibeActive  - method check if sebscribe are active
    const errorMessage = document.querySelector("[data-quantity-message]")

    const itemInCart = cart.items.find(item => item.id === currentVariant.id)

    if (itemInCart && (itemInCart.quantity + Number(input.value)) > 10) {
      errorMessage.classList.remove('hidden')
      return
    }
    if (input.value > 10) {
      errorMessage.classList.remove('hidden')
      return;
    } else {
      !errorMessage.classList.contains('hidden') && errorMessage.classList.add('hidden')
    }

    const checkIfSubsctibeActive = document.querySelector('.yotpo-radio-subscription-container.yotpo-selected');
    const attributes = [];
    let selling_plan = '';


    const props = {
      detail: {
        payload: {
          merchandiseId: currentVariantJson.id,
          selling_plan,
          attributes,
          quantity: input.value,
        },
      }
    };

    if (checkIfSubsctibeActive) {
      // push data to attributes depend of which is selected
      props.detail.payload.selling_plan = document.querySelector('[data-selling-plan-group-frequency-id] input:checked').value;
    }

    if (currentVariantJson.variantBundle) {
      const bundleDefaultVariantId = currentVariantJson.variantBundle.variants[0].id;
      props.detail.payload.merchandiseId = `gid://shopify/ProductVariant/${bundleDefaultVariantId}`
    }

    const addToCartEvent = new CustomEvent('cart:add', props);

    await document.dispatchEvent(addToCartEvent);

    // need to be used for future updates
    // if (currentVariant.quantityAvailable == alreadyAddedQty) {
    //   const currentVariantId = Number(currentVariant.id.split('/').pop());
    //   const currentCartItemToggle = document.querySelector(`#line-${currentVariantId} .toggle-error`)
    //   currentCartItemToggle.click();
    // }
    return
  };

  const getCart = async () => {
    cart = await AjaxService.get()

    alreadyAddedQty = cart.items.find(item => item.id == currentVariant.id)?.quantity;
  }

  function handleScroll() {
    const productForm = document.getElementById('productForm');
    const notifyMeButton = document.querySelector('#BIS_trigger');
    const stickyButton = document.querySelector('.sticky-product-button');
    const headerHeight = document.getElementById("shopify-section-promo-bar").offsetHeight;
    if (!productForm || !stickyButton) {
      console.error('Required elements are missing');
      return;
    }

    const productFormData = productForm.classList.contains('hidden') ? notifyMeButton.getBoundingClientRect() : productForm.getBoundingClientRect();
    const isBelowForm = productFormData.bottom - headerHeight - productFormData.height * 0.7 < 0;

    if (isBelowForm) {
      stickyButton.style.transform = 'translateY(0)';
    } else {
      stickyButton.style.transform = 'translateY(100%)';
    }
  }

  const initCorrectVariant = () => {
    if (window.location && window.location.toString().includes('products/')) {
      const searchParams = new URLSearchParams(window.location.search);
      const idVar = searchParams.get('variant');
      const corectVariant = variants.find(variant => variant.id.toString().includes(idVar))
      if (!corectVariant) {
        return
      }
      corectVariant.selectedOptions.map(selectedOption => {
        if (selectedOption.name == 'Color') {

          const options = element.querySelectorAll('[data-product-option-size]');
          options.forEach(option => {
            const optionValue = option.value;
            const filteredVariants = product.variants.filter(variant => variant.option1 === selectedOption.value);

            const isVisible = filteredVariants.some(variant =>
              variant.option2 === optionValue
            );

            option.parentNode.classList.toggle('hidden', !isVisible);
          });
        }
      })
    }
  }

  const hideForm = () => {
    if (!currentVariant) {
      return
    }
    if (!currentVariant.available) {
      productForm.classList.add('hidden')
    } else {
      productForm.classList.remove('hidden')
    }
  }

  const updateInput = () => {
    const input = element.querySelector('[data-quantity-input]');
    input.value = 1;
    yotpoPDPSubscriptionWidgetContent && addSubscriptionInfoBlock()
    hideForm()
  }

  const notifyMeSticky = () => {
    const buttonAddToCartSticky = element.querySelector('[data-sticky-product-button]');
    const productForm = element.querySelector('#productForm');

    const observer = new MutationObserver((mutationList, observer) => {
      if (element.querySelector('#BIS_trigger') && buttonAddToCartSticky && productForm.classList.contains('hidden')) {
        buttonAddToCartSticky.classList.add('notify-me');
        buttonAddToCartSticky.querySelector('span:first-child').innerText = buttonAddToCartSticky.getAttribute('data-notify-text');
      }

      if (!productForm.classList.contains('hidden')) {
        buttonAddToCartSticky.classList.remove('notify-me');
        buttonAddToCartSticky.querySelector('span:first-child').innerText = buttonAddToCartSticky.getAttribute('data-add-text');
      }

      setTimeout(() => {
        observer.disconnect();
      }, 10000);
    });

    observer.observe(element.querySelector('#ProductDescription'), { childList: true });

    if (element.querySelector('#BIS_trigger') && buttonAddToCartSticky && productForm.classList.contains('hidden')) {
      buttonAddToCartSticky.classList.add('notify-me');
      buttonAddToCartSticky.querySelector('span:first-child').innerText = buttonAddToCartSticky.getAttribute('data-notify-text');
    }

    if (!productForm.classList.contains('hidden')) {
      buttonAddToCartSticky.classList.remove('notify-me');
      buttonAddToCartSticky.querySelector('span:first-child').innerText = buttonAddToCartSticky.getAttribute('data-add-text');
    }
  }

  const init = async () => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('load', () => {
      setTimeout(() => {
        handleScroll();
      }, 2000);
    });
    productSliders = new ProductSliders('[data-slider-pg-top]', '[data-slider-pg-thumbs]')
    productSliders.init()

    const colorOptions = element.querySelectorAll('[data-product-option-color]');
    const sizeOptions = element.querySelectorAll('[data-product-option-size]');
    const productoptionCustom = element.querySelectorAll('[data-product-option-custom]');

    initCorrectVariant();
    getCurrentVariant();
    addToCartEvent();
    notifyMeSticky();

    productoptionCustom.forEach(option => option.addEventListener('change', async (e) => {
      const customOptionCurrentValueHolder = option.closest('.custom-options').querySelector('[data-custom-option-current-value]');
      if (customOptionCurrentValueHolder) customOptionCurrentValueHolder.innerText = option.value;
      getCurrentVariant(e);
      updateInput()
      notifyMeSticky();
    }))

    colorOptions.forEach(option => option.addEventListener('change', async (e) => {
      getCurrentVariant(e, true, false);
      updateInput()
      notifyMeSticky();
    }))

    sizeOptions.forEach(option => option.addEventListener('change', async (e) => {
      getCurrentVariant(e, false, true);
      updateInput()
      notifyMeSticky();
    }))

    hideForm()

    yotpoPDPSubscriptionWidgetContent && addSubscriptionInfoBlock()
    showFindationWidget && showFindationWidgetFunc()

    quantityLogic();
    await getCart();
    rewardsSliderRender()
  };
  
  init();
};
